import { createAction } from 'redux-actions';
import { SET_HOSTED_FROM_ADDRESS } from '../constants/actionTypes';
export const setHostedFromAddress = createAction(SET_HOSTED_FROM_ADDRESS, ({
  fromAddress
}) => ({
  fromAddress
}));